import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { EmptyState, Link } from '@atlassian/search-dialog';
import { FormattedMessage, injectIntl } from 'react-intl-next';
import { messages } from '../../messages';
import { Button } from './search-error.styled';
var Image = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_product-search-dialog/async-chunk/search-error-image" */'./image');
});
export var SearchError = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchError, _React$Component);
  var _super = _createSuper(SearchError);
  function SearchError() {
    var _this;
    _classCallCheck(this, SearchError);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getContent", function () {
      var onRetry = _this.props.onRetry;
      var linkComponent = function linkComponent(props) {
        return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
          role: "button",
          tabIndex: 0,
          onClick: function onClick() {
            return onRetry();
          },
          onKeyDown: function onKeyDown(event) {
            return event.key === 'Enter' ? onRetry() : undefined;
          }
        }));
      };
      return /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.common_error_state_failed_search_body, {
        values: {
          emptyLink: function emptyLink(s) {
            return /*#__PURE__*/React.createElement(Link, {
              linkComponent: linkComponent,
              href: ''
            }, s);
          }
        }
      }));
    });
    return _this;
  }
  _createClass(SearchError, [{
    key: "render",
    value: function render() {
      var intl = this.props.intl;
      return /*#__PURE__*/React.createElement(EmptyState, {
        title: intl.formatMessage(messages.common_error_state_failed_search_heading),
        Image: Image,
        content: this.getContent()
      });
    }
  }]);
  return SearchError;
}(React.Component);
export default injectIntl(SearchError);